// Settings › Workspace › Sign-in: every way members sign in (password, Microsoft, Google, single sign-on),
// the domains, two-step sign-in, IP rules and sessions — owner: S10 (settings IA).
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SignInMethodsPage } from '../../../features/access/SignInMethodsPage';

export const Route = createFileRoute('/_settings/settings/sign-in')({
  validateSearch: z.object({
    sso_test: z.enum(['ok', 'failed']).optional(),
    sso_email: z.string().max(254).optional(),
    sso_error: z.string().max(300).optional(),
  }),
  component: SignInRoute,
});

function SignInRoute() {
  const s = Route.useSearch();
  return (
    <SignInMethodsPage
      ssoTest={
        s.sso_test
          ? {
              status: s.sso_test,
              ...(s.sso_email ? { email: s.sso_email } : {}),
              ...(s.sso_error ? { error: s.sso_error } : {}),
            }
          : undefined
      }
    />
  );
}
